import { DisplayTraceabilityDto } from '../../../shared/traceability/display-traceability.dto';
import { AssessmentDto } from '../assessment/assessment-details/assessment.dto';
import { ContractActionDto } from './contract-action.dto';
import { ContratBeneficiaryStatus } from './contract-enum';

export class ContractDto {
  public mainPurpose: string;
  public achievement: string;
  public project: string;
  public actionsToPerform: string;
  public statusDate: Date;
  public traceability: DisplayTraceabilityDto[];
  public quarterlyDeclarationResources: boolean;
  public professionalResources: boolean;
  public otherResources: boolean;
  public verificationFamilySituation: boolean;
  public verificationCAFAddress: boolean;
  public rsaIncreased: boolean;
  public beneficiaryStatus: ContratBeneficiaryStatus;
  public actions: ContractActionDto[];
  public comment: string;
  public assessmentId: number;
  public assessment: AssessmentDto;

  constructor(
    public id: number,
    public beginDate: Date,
    public endDate: Date,
    public idBeneficiary: number,
    public contractType: string,
    public status: string,
    args: {
      mainPurpose?: string;
      achievement?: string;
      project?: string;
      actionsToPerform?: string;
      statusDate?: Date;
      traceability?: DisplayTraceabilityDto[];
      quarterlyDeclarationResources?: boolean;
      professionalResources?: boolean;
      otherResources?: boolean;
      verificationFamilySituation?: boolean;
      verificationCAFAddress?: boolean;
      rsaIncreased?: boolean;
      beneficiaryStatus?: ContratBeneficiaryStatus;
      actions?: ContractActionDto[];
      comment?: string;
      assessmentId?: number;
      assessment?: AssessmentDto;
    },
  ) {
    this.mainPurpose = args.mainPurpose;
    this.achievement = args.achievement;
    this.project = args.project;
    this.actionsToPerform = args.actionsToPerform;
    this.statusDate = args.statusDate;
    this.traceability = args.traceability;
    this.quarterlyDeclarationResources = args.quarterlyDeclarationResources;
    this.professionalResources = args.professionalResources;
    this.otherResources = args.otherResources;
    this.verificationFamilySituation = args.verificationFamilySituation;
    this.verificationCAFAddress = args.verificationCAFAddress;
    this.rsaIncreased = args.rsaIncreased;
    this.beneficiaryStatus = args.beneficiaryStatus;
    this.actions = args.actions;
    this.comment = args.comment;
    this.assessmentId = args.assessmentId;
    this.assessment = args.assessment;
  }

  public static fromJson(json: any): ContractDto {
    return new ContractDto(
      json.id,
      json.beginDate ? new Date(json.beginDate) : undefined,
      json.endDate ? new Date(json.endDate) : undefined,
      json.idBeneficiary,
      json.contractType,
      json.status,
      {
        mainPurpose: json.mainPurpose,
        achievement: json.achievement,
        project: json.project,
        actionsToPerform: json.actionsToPerform,
        statusDate: json.statusDate ? new Date(json.statusDate) : undefined,
        traceability: json.traceability,
        quarterlyDeclarationResources: json.quarterlyDeclarationResources,
        professionalResources: json.professionalResources,
        otherResources: json.otherResources,
        verificationFamilySituation: json.verificationFamilySituation,
        verificationCAFAddress: json.verificationCAFAddress,
        rsaIncreased: json.rsaIncreased,
        beneficiaryStatus: json.beneficiaryStatus,
        actions: json.actions,
        comment: json.comment,
        assessmentId: json.assessmentId,
        assessment: json.assessment,
      },
    );
  }
}
